import { Preferences } from '@capacitor/preferences';
import { ref, watch } from 'vue';

export function usePreferenceStorage<T>(key: string, opts?: { default?: T; json?: boolean }) {
  const state = ref<T | undefined>(opts?.default);
  const initialized = ref(false);
  const awaitingInitCBs: Array<() => void> = [];

  async function init() {
    const result = await Preferences.get({ key });
    if (result.value) {
      state.value = opts?.json
        ? JSON.parse(result.value)
        : result.value?.toLowerCase() === 'true'
        ? true
        : result.value?.toLowerCase() === 'false'
        ? false
        : result.value;
    }
    initialized.value = true;
    let cb = awaitingInitCBs.pop();
    while (cb) {
      cb();
      cb = awaitingInitCBs.pop();
    }
  }

  function waitForInit(): Promise<void> {
    if (initialized.value) {
      return Promise.resolve();
    }
    return new Promise<void>((resolve) => {
      awaitingInitCBs.push(resolve);
    });
  }

  watch(state, async (val) => {
    if (val !== null && val !== undefined && val !== '') {
      await Preferences.set({
        key,
        value: typeof val === 'string' ? val : typeof val === 'boolean' ? val.toString() : JSON.stringify(val),
      });
    } else {
      await Preferences.remove({ key });
    }
  });

  init();
  return { state, initialized, waitForInit };
}
